/**
 * Predefined color list for product variants (fashion/fabric).
 * Used by ColorSelect; already-selected colors for the same product are excluded via excludeColors.
 */
export const COLORS = [
  { name: 'Black', hex: '#000000' },
  { name: 'White', hex: '#ffffff' },
  { name: 'Navy', hex: '#000080' },
  { name: 'Maroon', hex: '#800000' },
  { name: 'Red', hex: '#dc2626' },
  { name: 'Blue', hex: '#2563eb' },
  { name: 'Pink', hex: '#ec4899' },
  { name: 'Green', hex: '#16a34a' },
  { name: 'Grey', hex: '#6b7280' },
  { name: 'Gray', hex: '#6b7280' },
  { name: 'Beige', hex: '#d4c4a8' },
  { name: 'Brown', hex: '#92400e' },
  { name: 'Yellow', hex: '#eab308' },
  { name: 'Orange', hex: '#ea580c' },
  { name: 'Purple', hex: '#7c3aed' },
  { name: 'Sky Blue', hex: '#0ea5e9' },
  { name: 'Cream', hex: '#fef9c3' },
  { name: 'Charcoal', hex: '#374151' },
  { name: 'Gold', hex: '#d97706' },
  { name: 'Silver', hex: '#9ca3af' },
  { name: 'Olive', hex: '#84cc16' },
  { name: 'Teal', hex: '#0d9488' },
  { name: 'Coral', hex: '#f97316' },
  { name: 'Lavender', hex: '#a78bfa' },
  { name: 'Peach', hex: '#fec89a' },
  { name: 'Mustard', hex: '#ca8a04' },
  { name: 'Burgundy', hex: '#881337' },
  { name: 'Turquoise', hex: '#2dd4bf' },
  { name: 'Wine', hex: '#722f37' },
  { name: 'Chocolate', hex: '#78350f' },
  { name: 'Mint', hex: '#6ee7b7' },
  { name: 'Ivory', hex: '#fffff0' },
  { name: 'Off White', hex: '#faf9f6' },
  { name: 'Snow', hex: '#fffafa' },
  { name: 'Linen', hex: '#faf0e6' },
  { name: 'Antique White', hex: '#faebd7' },
  { name: 'Floral White', hex: '#fffaf0' },
  { name: 'Honeydew', hex: '#f0fff0' },
  { name: 'Azure', hex: '#f0ffff' },
  { name: 'Alice Blue', hex: '#f0f8ff' },
  { name: 'Ghost White', hex: '#f8f8ff' },
  { name: 'Seashell', hex: '#fff5ee' },
  { name: 'Misty Rose', hex: '#ffe4e1' },
  { name: 'Light Pink', hex: '#ffb6c1' },
  { name: 'Hot Pink', hex: '#ff69b4' },
  { name: 'Deep Pink', hex: '#ff1493' },
  { name: 'Medium Violet Red', hex: '#c71585' },
  { name: 'Pale Violet Red', hex: '#db7093' },
  { name: 'Crimson', hex: '#dc143c' },
  { name: 'Fire Brick', hex: '#b22222' },
  { name: 'Dark Red', hex: '#8b0000' },
  { name: 'Indian Red', hex: '#cd5c5c' },
  { name: 'Light Coral', hex: '#f08080' },
  { name: 'Salmon', hex: '#fa8072' },
  { name: 'Dark Salmon', hex: '#e9967a' },
  { name: 'Light Salmon', hex: '#ffa07a' },
  { name: 'Tomato', hex: '#ff6347' },
  { name: 'Orange Red', hex: '#ff4500' },
  { name: 'Dark Orange', hex: '#ff8c00' },
  { name: 'Light Yellow', hex: '#ffffe0' },
  { name: 'Lemon Chiffon', hex: '#fffacd' },
  { name: 'Light Goldenrod', hex: '#fafad2' },
  { name: 'Papaya Whip', hex: '#ffefd5' },
  { name: 'Moccasin', hex: '#ffe4b5' },
  { name: 'Wheat', hex: '#f5deb3' },
  { name: 'Tan', hex: '#d2b48c' },
  { name: 'Rosy Brown', hex: '#bc8f8f' },
  { name: 'Sandy Brown', hex: '#f4a460' },
  { name: 'Peru', hex: '#cd853f' },
  { name: 'Sienna', hex: '#a0522d' },
  { name: 'Saddle Brown', hex: '#8b4513' },
  { name: 'Dark Goldenrod', hex: '#b8860b' },
  { name: 'Dark Khaki', hex: '#bdb76b' },
  { name: 'Khaki', hex: '#f0e68c' },
  { name: 'Pale Green', hex: '#98fb98' },
  { name: 'Light Green', hex: '#90ee90' },
  { name: 'Spring Green', hex: '#00ff7f' },
  { name: 'Medium Spring Green', hex: '#00fa9a' },
  { name: 'Medium Sea Green', hex: '#3cb371' },
  { name: 'Sea Green', hex: '#2e8b57' },
  { name: 'Forest Green', hex: '#228b22' },
  { name: 'Dark Green', hex: '#006400' },
  { name: 'Dark Olive Green', hex: '#556b2f' },
  { name: 'Olive Drab', hex: '#6b8e23' },
  { name: 'Yellow Green', hex: '#9acd32' },
  { name: 'Lime Green', hex: '#32cd32' },
  { name: 'Light Sea Green', hex: '#20b2aa' },
  { name: 'Medium Turquoise', hex: '#48d1cc' },
  { name: 'Dark Turquoise', hex: '#00ced1' },
  { name: 'Cadet Blue', hex: '#5f9ea0' },
  { name: 'Steel Blue', hex: '#4682b4' },
  { name: 'Light Steel Blue', hex: '#b0c4de' },
  { name: 'Powder Blue', hex: '#b0e0e6' },
  { name: 'Light Blue', hex: '#add8e6' },
  { name: 'Deep Sky Blue', hex: '#00bfff' },
  { name: 'Dodger Blue', hex: '#1e90ff' },
  { name: 'Royal Blue', hex: '#4169e1' },
  { name: 'Medium Blue', hex: '#0000cd' },
  { name: 'Dark Blue', hex: '#00008b' },
  { name: 'Midnight Blue', hex: '#191970' },
  { name: 'Indigo', hex: '#4b0082' },
  { name: 'Blue Violet', hex: '#8a2be2' },
  { name: 'Medium Purple', hex: '#9370db' },
  { name: 'Medium Slate Blue', hex: '#7b68ee' },
  { name: 'Slate Blue', hex: '#6a5acd' },
  { name: 'Dark Slate Blue', hex: '#483d8b' },
  { name: 'Dark Violet', hex: '#9400d3' },
  { name: 'Dark Magenta', hex: '#8b008b' },
  { name: 'Orchid', hex: '#da70d6' },
  { name: 'Medium Orchid', hex: '#ba55d3' },
  { name: 'Plum', hex: '#dda0dd' },
  { name: 'Thistle', hex: '#d8bfd8' },
  { name: 'Violet', hex: '#ee82ee' },
  { name: 'Magenta', hex: '#ff00ff' },
  { name: 'Fuchsia', hex: '#ff00ff' },
  { name: 'Dark Grey', hex: '#a9a9a9' },
  { name: 'Dark Gray', hex: '#a9a9a9' },
  { name: 'Dim Grey', hex: '#696969' },
  { name: 'Dim Gray', hex: '#696969' },
  { name: 'Light Grey', hex: '#d3d3d3' },
  { name: 'Light Gray', hex: '#d3d3d3' },
  { name: 'Slate Grey', hex: '#708090' },
  { name: 'Slate Gray', hex: '#708090' },
  { name: 'Light Slate Grey', hex: '#778899' },
  { name: 'Light Slate Gray', hex: '#778899' },
  { name: 'Snow White', hex: '#fffafa' },
  { name: 'Pearl', hex: '#eae0c8' },
  { name: 'Blush', hex: '#de5d83' },
  { name: 'Dusty Rose', hex: '#dcae96' },
  { name: 'Rose', hex: '#ff007f' },
  { name: 'Dusty Pink', hex: '#dca2b0' },
  { name: 'Nude', hex: '#e3c6a8' },
  { name: 'Camel', hex: '#c19a6b' },
  { name: 'Caramel', hex: '#ffddaf' },
  { name: 'Coffee', hex: '#6f4e37' },
  { name: 'Espresso', hex: '#4a3728' },
  { name: 'Mocha', hex: '#967969' },
  { name: 'Rust', hex: '#b7410e' },
  { name: 'Terracotta', hex: '#e2725b' },
  { name: 'Copper', hex: '#b87333' },
  { name: 'Bronze', hex: '#cd7f32' },
  { name: 'Brass', hex: '#b5a642' },
  { name: 'Amber', hex: '#ffbf00' },
  { name: 'Saffron', hex: '#f4c430' },
  { name: 'Lime', hex: '#bfff00' },
  { name: 'Sage', hex: '#9dc183' },
  { name: 'Sage Green', hex: '#9dc183' },
  { name: 'Forest', hex: '#228b22' },
  { name: 'Hunter Green', hex: '#355e3b' },
  { name: 'Emerald', hex: '#50c878' },
  { name: 'Jade', hex: '#00a86b' },
  { name: 'Aqua', hex: '#00ffff' },
  { name: 'Cyan', hex: '#00ffff' },
  { name: 'Navy Blue', hex: '#000080' },
  { name: 'Cobalt', hex: '#0047ab' },
  { name: 'Electric Blue', hex: '#7df9ff' },
  { name: 'Baby Blue', hex: '#89cff0' },
  { name: 'Cornflower Blue', hex: '#6495ed' },
  { name: 'Denim', hex: '#1560bd' },
  { name: 'Slate', hex: '#708090' },
  { name: 'Gunmetal', hex: '#2a3439' },
  { name: 'Graphite', hex: '#383838' },
  { name: 'Ash', hex: '#b2beb5' },
  { name: 'Smoke', hex: '#738276' },
  { name: 'Stone', hex: '#928e85' },
  { name: 'Taupe', hex: '#483c32' },
  { name: 'Fawn', hex: '#e5aa70' },
  { name: 'Sand', hex: '#c2b280' },
  { name: 'Blonde', hex: '#faf0be' },
  { name: 'Lilac', hex: '#c8a2c8' },
  { name: 'Mauve', hex: '#e0b0ff' },
  { name: 'Plum Purple', hex: '#8e4585' },
  { name: 'Eggplant', hex: '#614051' },
  { name: 'Mulberry', hex: '#c54b8c' },
  { name: 'Raspberry', hex: '#e30b5c' },
  { name: 'Strawberry', hex: '#fc5a8d' },
  { name: 'Cherry', hex: '#de3163' },
  { name: 'Scarlet', hex: '#ff2400' },
  { name: 'Vermillion', hex: '#e34234' },
  { name: 'Tangerine', hex: '#ff9966' },
  { name: 'Apricot', hex: '#fbceb1' },
  { name: 'Melon', hex: '#fdbcb4' },
  { name: 'Persimmon', hex: '#ec5800' },
  { name: 'Paprika', hex: '#8f0000' },
  { name: 'Rouge', hex: '#a23b6c' },
  { name: 'Claret', hex: '#7f1734' },
  { name: 'Oxblood', hex: '#4a0000' },
  { name: 'Mahogany', hex: '#c04000' },
  { name: 'Cinnamon', hex: '#d2691e' },
  { name: 'Nutmeg', hex: '#783e2e' },
  { name: 'Sepia', hex: '#704214' },
  { name: 'Umber', hex: '#635147' },
  { name: 'Ochre', hex: '#cc7722' },
  { name: 'Hazel', hex: '#8e7618' },
  { name: 'Fern', hex: '#71bc78' },
  { name: 'Moss', hex: '#8a9a5b' },
  { name: 'Avocado', hex: '#568203' },
  { name: 'Kelly Green', hex: '#4cbb17' },
  { name: 'Army Green', hex: '#4b5320' },
  { name: 'Bottle Green', hex: '#006a4e' },
  { name: 'Pine Green', hex: '#01796f' },
  { name: 'Peacock', hex: '#006a50' },
  { name: 'Cobalt Blue', hex: '#0047ab' },
  { name: 'Prussian Blue', hex: '#003153' },
  { name: 'Sapphire', hex: '#0f52ba' },
  { name: 'Azure Blue', hex: '#007fff' },
  { name: 'Ice Blue', hex: '#d4f1f4' },
  { name: 'Arctic Blue', hex: '#e6f3f5' },
  { name: 'Lavender Blue', hex: '#ccccff' },
  { name: 'Periwinkle', hex: '#ccccff' },
  { name: 'Wisteria', hex: '#c9a0dc' },
  { name: 'Heliotrope', hex: '#df73ff' },
  { name: 'Amethyst', hex: '#9966cc' },
  { name: 'Grape', hex: '#6f2da8' },
  { name: 'Raisin', hex: '#2c1632' },
  { name: 'Ink', hex: '#1b0f22' },
  { name: 'Onyx', hex: '#353839' },
  { name: 'Jet Black', hex: '#0a0a0a' },
  { name: 'Pearl White', hex: '#f8f6f0' },
  { name: 'Oyster', hex: '#e3dcc8' },
  { name: 'Dove', hex: '#9b9b9b' },
  { name: 'Pewter', hex: '#8b8589' },
  { name: 'Steel', hex: '#71797e' },
  { name: 'Iron', hex: '#5a5a5a' },
  { name: 'Tin', hex: '#c0c0c0' },
  { name: 'Champagne', hex: '#f7e7ce' },
  { name: 'Blush Pink', hex: '#de5d83' },
  { name: 'Rose Gold', hex: '#b76e79' },
  { name: 'Copper Penny', hex: '#ad6f69' },
  { name: 'Antique Gold', hex: '#b8860b' },
  { name: 'Metallic Gold', hex: '#d4af37' },
  { name: 'Metallic Silver', hex: '#aaa9ad' },
  { name: 'Metallic Bronze', hex: '#8c7853' }
];

export default COLORS;
